export const steps = {
  planSelection: 'plan-selection',
  checkout: 'checkout',
} as const;

export type Step = (typeof steps)[keyof typeof steps];

export const dateFormat = 'MMMM d, yyyy';
